import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";

interface DataContextProps {
  metricasEspecialidades: any;
  tempoMedio7dias: any[];
  tempoMedio24horas: any[];
  especialidades: any[];
  detalhado: Detalhado;
  listOptinsEspecialidades: any[];
  selectedEspecialidades: any;
  setSelectedEspecialidade: any;
  selectedHospital: any;
  setSelectedHospital: any;
  macrorregiaoColorMap: any;
  especialidadesColorMap: any;

  loading: boolean;
  isSmallScreen: boolean;
}

interface Detalhado {
  [hospital: string]: {
    [especialidade: string]: any;
  };
}

const DataContext = createContext<DataContextProps | undefined>(undefined);

const DataProvider: React.FC = ({ children }: any) => {
  // const [data, setData] = useState<any[]>([]);
  const [metricasEspecialidades, setMetricasEspecialidades] = useState<any[]>(
    []
  );
  const [tempoMedio7dias, setTempoMedio7dias] = useState<any[]>([]);
  const [tempoMedio24horas, setTempoMedio24horas] = useState<any[]>([]);
  const [especialidades, setEspecialidades] = useState<any>([]);
  const [detalhado, setDetalhado] = useState<Detalhado>({});
  const [selectedEspecialidades, setSelectedEspecialidade] =
    useState<any>("Clínica Médica");
  const [selectedHospital, setSelectedHospital] = useState<any>("Todos");
  const [listOptinsEspecialidades, setListOptinsEspecialidades] = useState<any>(
    []
  );

  const [loading, setLoading] = useState<boolean>(true);
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    window.innerWidth <= 1024
  );

  useEffect(() => {
    function handleResize() {
      setIsSmallScreen(window.innerWidth <= 1024);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // const [reloader, setReloader] = useState(false);

  const teste: any[] = [];

  const hospitais = [
    "HRT",
    "HRSam",
    "HRC",
    "HRBz",
    "HSVP",
    "HRG",
    "HRGu",
    "HRAN",
    "HMIB",
    "HRS",
    "HRL",
    "HRPL",
  ];

  const macrorregioesColors = {
    macrorregiao1: "#527d9b",
    macrorregiao2: "#ED94AA",
    macrorregiao3: "#af6c9c",
  };
  const macrorregiaoColorMap = {
    HRBz: macrorregioesColors.macrorregiao1,
    HRC: macrorregioesColors.macrorregiao1,
    HRSam: macrorregioesColors.macrorregiao1,
    HSVP: macrorregioesColors.macrorregiao1,
    HRT: macrorregioesColors.macrorregiao1,
    HRGu: macrorregioesColors.macrorregiao2,
    HRG: macrorregioesColors.macrorregiao2,
    HMIB: macrorregioesColors.macrorregiao2,
    HRAN: macrorregioesColors.macrorregiao2,
    HRPL: macrorregioesColors.macrorregiao3,
    HRS: macrorregioesColors.macrorregiao3,
    HRL: macrorregioesColors.macrorregiao3,
  };

  const especialidadesColorMap = {
    "Cirurgia Geral": "#d8600e",
    "Clínica Médica": "#8942df",
    Ortopedia: "#4fdd8d",
    Pediatria: "#8791c3",
    "Gineco Obstetrícia": "#c37881",
    Odontologia: "#f3a930",
    Oftalmologia: "#3b8bba",
    Cardiologia: "#e74c3c",
    Psiquiatria: "#6a4c93",
    "Cirurgia Plástica": "#d16d2c",
    "Cirurgia Pediátrica": "#f1c40f",
    "Emergência Clínica": "#2ecc71",
    // Observação: "#8e44ad",
    // "Pronto Socorro": "#1abc9c",
    // Queimados: "#9b59b6",
    // "Sala De Infusao": "#e67e22",
    // "Sala Vermelha Clinica": "#3498db",
    // "Medicação Dia": "#9b59b6",
  };

  function useFetchPeriodically() {
    const timerRef = useRef<number | null>(null);

    useEffect(() => {
      const fetchData = async () => {
        try {
          console.log(
            "Buscando dados do cache/backend...",
            new Date().toLocaleTimeString()
          );

          const response = await fetch("/api/hospitais");

          if (!response.ok) {
            console.log("Alguma requisição não retornou 200");
            console.log("Tentando novamente em 3 segundos");
            setTimeout(() => {
              return fetchData();
            }, 3000);
          }

          const data = await response.json();

          // lê o cabeçalho x-cache-expire enviado pelo servidor express
          const expireHeader = response.headers.get("x-cache-expire");
          if (expireHeader) {
            const expireTime = new Date(expireHeader).getTime();
            const now = Date.now();
            const delay = expireTime - now + 10_000; // +10s de margem

            if (delay > 0) {
              console.log(
                `⏱️ Próximo fetch agendado para ${new Date(
                  now + delay
                ).toLocaleTimeString()}`
              );

              // limpa qualquer timer anterior e agenda o próximo fetch
              if (timerRef.current !== null) clearTimeout(timerRef.current);
              timerRef.current = window.setTimeout(fetchData, delay);
            }
          }

          if (Array.isArray(data) && data.length >= 4) {
            const [data0, data1, data2, data3] = data;

            if (data0) {
              const modifiedArray = modifyArray(data0);
              const resultadoPorHospital: any = hospitais.reduce(
                (acc: any, hospital) => {
                  acc[hospital] = [];
                  return acc;
                },
                {}
              );

              modifiedArray.forEach((item: any) => {
                if (resultadoPorHospital[item.i_desc_local_passagem]) {
                  resultadoPorHospital[item.i_desc_local_passagem].push(item);
                }
              });

              processarDados(resultadoPorHospital);
              setMetricasEspecialidades(resultadoPorHospital);
            }

            if (data1) {
              const modifiedArray = modifyArray(data1);
              const resultadoPorHospital: any = hospitais.reduce(
                (acc: any, hospital) => {
                  acc[hospital] = [];
                  return acc;
                },
                {}
              );

              modifiedArray.forEach((item: any) => {
                if (resultadoPorHospital[item.i_desc_local_passagem]) {
                  resultadoPorHospital[item.i_desc_local_passagem].push(item);
                }
              });

              const dadosTemporais = true;
              processarDados(resultadoPorHospital, dadosTemporais);
              setTempoMedio7dias(resultadoPorHospital);
            }

            if (data2) {
              const modifiedArray = modifyArray(data2);
              const resultadoPorHospital: any = hospitais.reduce(
                (acc: any, hospital) => {
                  acc[hospital] = [];
                  return acc;
                },
                {}
              );

              modifiedArray.forEach((item: any) => {
                if (resultadoPorHospital[item.i_desc_local_passagem]) {
                  resultadoPorHospital[item.i_desc_local_passagem].push(item);
                }
              });

              processarDados(resultadoPorHospital);
              setDetalhado(resultadoPorHospital);
            }

            if (data3) {
              const modifiedArray = modifyArray(data3);
              const resultadoPorHospital: any = hospitais.reduce(
                (acc: any, hospital) => {
                  acc[hospital] = [];
                  return acc;
                },
                {}
              );

              modifiedArray.forEach((item: any) => {
                if (resultadoPorHospital[item.i_desc_local_passagem]) {
                  resultadoPorHospital[item.i_desc_local_passagem].push(item);
                }
              });

              const dadosTemporais = true;
              processarDados(resultadoPorHospital, dadosTemporais);
              setTempoMedio24horas(resultadoPorHospital);
            }

            setLoading(false);
          } else {
            console.log("Erro na requisição de algum endpoint");
          }
        } catch (err) {
          console.log("Erro:", err);
          // tenta novamente em 1 minuto se algo der errado
          if (timerRef.current !== null) clearTimeout(timerRef.current);
          timerRef.current = window.setTimeout(fetchData, 60_000);
        }
      };

      fetchData();

      return () => {
        if (timerRef.current !== null) {
          clearTimeout(timerRef.current);
        }
      };
    }, []);
  }

  const toTitleCase = (str: any) => {
    // // Remove aspas da string
    // const cleanedStr = str.replace(/"/g, "").trim();

    // // Divide a string em partes usando espaço, hífen ou barra como separadores (mantém espaços)
    // const parts = cleanedStr.split(/[\s\-\/]/);

    // // Transforma cada palavra com a primeira letra maiúscula e o restante em minúsculas
    // const titleCaseStr = parts
    //   .map((part: any) => {
    //     return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    //   })
    //   .join(" ");

    // return titleCaseStr;

    // Remove aspas da string e espaços extras ao redor
    const cleanedStr = str.replace(/"/g, "").trim();

    // Divide a string em partes usando espaço, hífen ou barra como separadores (mantém espaços)
    const parts = cleanedStr.split(/[\s\-/]/);

    // Remove espaços vazios que estejam como a primeira parte
    if (parts[0] === "") {
      parts.shift(); // Remove o primeiro elemento se for um espaço vazio
    }

    // Transforma cada palavra com a primeira letra maiúscula e o restante em minúsculas
    const titleCaseStr = parts
      .map((part: any) => {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      })
      .join(" ");

    return titleCaseStr;
  };

  const modifyArray = (arr: any) => {
    const seenValues = new Set();

    return arr
      .map((item: any) => {
        // Desestruturação para criar uma cópia do objeto
        const { i_desc_local_passagem_completa } = item;

        // Verifica se o valor é "Pronto Socorro" ou "- PRONTO SOCORRO"
        const isProntoSocorro =
          i_desc_local_passagem_completa.toLowerCase() === "pronto socorro" ||
          i_desc_local_passagem_completa.toLowerCase() === "- pronto socorro";

        // Define o valor padronizado para "Pronto Socorro" ou mantém o valor original
        let newValue = isProntoSocorro
          ? "Pronto Socorro"
          : i_desc_local_passagem_completa;

        // Condição adicional para transformar "Clinica Medica" em "Clínica Médica"
        if (newValue.toLowerCase() === "clinica medica") {
          newValue = "Clínica Médica";
        }

        if (
          newValue.toLowerCase() === " pronto socorro" ||
          newValue.toLowerCase() === "hrlpronto socorro fila adulto" ||
          newValue.toLowerCase() === "  pronto socorro"
        ) {
          newValue = "Pronto Socorro";
        }

        if (newValue.toLowerCase() === " clinica medica") {
          newValue = "Clínica Médica";
        }

        if (
          newValue.toLowerCase() === "gineco/obstetricia" ||
          newValue.toLowerCase() === " gineco/obstetricia"
        ) {
          newValue = "Gineco Obstetrícia";
        }

        // Condição para transformar "Gineco Obstetricia" em "Gineco Obstetrícia"
        if (
          newValue.toLowerCase() === "gineco-obstetrico" ||
          newValue.toLowerCase() === " gineco-obstetrico"
        ) {
          newValue = "Gineco Obstetrícia";
        }

        if (
          newValue.toLowerCase() === "gineco/obstetrica" ||
          newValue.toLowerCase() === " gineco/obstetrica"
        ) {
          newValue = "Gineco Obstetrícia";
        }

        if (newValue.toLowerCase() === "ginecoobstetrico") {
          newValue = "Gineco Obstetrícia";
        }

        if (newValue.toLowerCase() === "medicacao dia") {
          newValue = "Medicação dia";
        }

        // Converte para title case e remove aspas
        const titleCaseValue = toTitleCase(newValue);

        // Se já existir "Pronto Socorro" no Set e o valor atual for uma variante de "Pronto Socorro", não adiciona
        if (
          titleCaseValue === "Pronto Socorro" &&
          seenValues.has("Pronto Socorro")
        ) {
          return null; // Retorna null para ignorar essa entrada
        }

        // Adiciona o valor ao Set para evitar duplicatas
        seenValues.add(titleCaseValue);

        return {
          ...item,
          i_desc_local_passagem_completa: titleCaseValue,
        };
      })
      .filter(Boolean); // Filtra itens que foram marcados como null para removê-los
  };

  // Função para agrupar os objetos por 'i_desc_local_passagem_completa'
  function agruparPorDescLocalPassagemCompleta(hospitalData: any) {
    const agrupado: any = {};

    hospitalData.forEach((item: any) => {
      const key = item.i_desc_local_passagem_completa;

      if (!agrupado[key]) {
        agrupado[key] = [];
      }

      teste.push(key);

      agrupado[key].push(item);
    });

    return agrupado;
  }

  const createArrayWithLabelValue = (arr: any) => {
    // Set para rastrear valores únicos

    return arr.reduce((acc: any, item: any) => {
      // Se o valor já existir no Set, ignorar e não adicionar ao array

      acc.push({ label: item, value: item });

      return acc;
    }, []);
  };

  // Função principal para percorrer todos os hospitais e aplicar o agrupamento
  function processarDados(data: any, dadosTemporais: boolean = false) {
    Object.keys(data).forEach((hospital) => {
      const hospitalData = data[hospital];
      const agrupado = agruparPorDescLocalPassagemCompleta(hospitalData);
      data[hospital] = agrupado;
      const uniqueItems = Array.from(new Set(teste));

      if (!dadosTemporais) {
        const especialidadesTratadas = [...especialidades, ...uniqueItems];

        setEspecialidades(Array.from(new Set(especialidadesTratadas)));

        const valorEspecialidades = createArrayWithLabelValue(uniqueItems);

        const sortedArray = valorEspecialidades.sort((a: any, b: any) => {
          return a.label.localeCompare(b.label);
        });

        setListOptinsEspecialidades(sortedArray);
      }
    });
  }

  useFetchPeriodically();

  return (
    <DataContext.Provider
      value={{
        metricasEspecialidades,
        detalhado,
        tempoMedio7dias,
        tempoMedio24horas,
        especialidades,
        loading,
        isSmallScreen,
        selectedEspecialidades,
        setSelectedEspecialidade,
        selectedHospital,
        setSelectedHospital,
        listOptinsEspecialidades,
        macrorregiaoColorMap,
        especialidadesColorMap,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };

export const useDataContext = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error("useDataContext must be used within a DataProvider");
  }
  return context;
};
